module.exports = __webpack_public_path__ + "static/media/logo-rectangle.b3af13fe.png";